import { subscribeToLeads, type Lead, type LeadsQueryFilters } from '@services/firebase/firestore';
import { useEffect, useState } from 'react';

export const useLeads = (filters: LeadsQueryFilters) => {
  const [leads, setLeads] = useState<Lead[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Only subscribe if at least one filter is applied
    const hasFilters =
      (filters.businessType && filters.businessType.length > 0) ||
      (filters.listId && filters.listId.length > 0) ||
      (filters.cityId && filters.cityId.length > 0) ||
      (filters.technology && filters.technology.length > 0) ||
      (filters.contactInfo && filters.contactInfo.length > 0) ||
      (filters.leadStatus && filters.leadStatus.length > 0);

    if (!hasFilters) {
      setLeads([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = subscribeToLeads(
      filters,
      (leadsData) => {
        setLeads(leadsData);
        setLoading(false);
      },
      (err) => {
        console.error('Leads subscription error:', err);
        setError(err.message || 'Failed to load leads');
        setLoading(false);
      }
    );

    return () => {
      unsubscribe();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(filters.businessType), JSON.stringify(filters.listId), JSON.stringify(filters.cityId), JSON.stringify(filters.technology), JSON.stringify(filters.contactInfo), JSON.stringify(filters.leadStatus), filters.currentUserUid]);

  return {
    leads,
    loading,
    error,
  };
};
